import { render, staticRenderFns } from "./payments-item.vue?vue&type=template&id=272585ef"
import script from "./payments-item.vue?vue&type=script&lang=js"
export * from "./payments-item.vue?vue&type=script&lang=js"
import style0 from "./payments-item.vue?vue&type=style&index=0&id=272585ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports